import { render } from "./choose.vue?vue&type=template&id=8543ffae"
import script from "./choose.vue?vue&type=script&lang=js"
export * from "./choose.vue?vue&type=script&lang=js"

import "./choose.vue?vue&type=style&index=0&id=8543ffae&lang=less"
script.render = render

export default script